<template>
  <el-tooltip class="item" effect="dark" :content="value" placement="top">
    <span>{{ showVal }}</span>
  </el-tooltip>
</template>

<script>
export default {
  props: {
    value: {
      type: [String],
      default: () => {
        return ''
      }
    }
  },
  computed: {
    showVal() {
      let res = ''
      if (this.value) {
        if (this.value.length > 10) {
          res =
            this.value.substring(0, 5) +
            '...' +
            this.value.substring(this.value.length - 4)
        } else {
          res = this.value
        }
      }
      return res
    }
  },
  watch: {},
  methods: {}
}
</script>
<style scoped lang="scss"></style>
